import React from 'react';
import { Section } from './Section';
const comparisonRows = [{
  sin: '3-5 hs/semana planificando desde cero',
  con: '10 min/semana. El resto es enseñar.',
  icon: '⏰'
}, {
  sin: 'Siempre los mismos ejercicios',
  con: '60+ clases distintas',
  icon: '😓'
}, {
  sin: 'Alumnos que abandonan sin saber por qué',
  con: 'Progresión → retención visible',
  icon: '💸'
}, {
  sin: 'Sin progresión clara de nivel a nivel',
  con: '6 tomos con progresión anual',
  icon: '📋'
}, {
  sin: 'Alumno con lesión = pánico',
  con: 'Cuerpo Seguro Pro → adaptación segura',
  icon: '😨'
}, {
  sin: 'Niveles mezclados = caos',
  con: 'Variaciones en 3 niveles',
  icon: '👥'
}, {
  sin: 'Sin sistema de comunicación',
  con: '18 flyers + 30 días de contenido',
  icon: '📱'
}, {
  sin: 'Sin identidad profesional visible',
  con: 'Sistema que justifica cobrar más',
  icon: '💼'
}];
export function ComparisonTable() {
  return <Section className="bg-brand-light !py-8 md:!py-12" data-id="element-47">
      <div className="text-center mb-4 md:mb-6" data-id="element-48">
        <div className="text-brand-accent font-bold tracking-widest text-xs mb-1.5" data-id="element-49">
          STRETCHING RESUELTO™
        </div>
        <h2 className="text-xl md:text-3xl font-display font-black text-white mb-2 max-w-3xl mx-auto leading-tight" data-id="element-50">
          El próximo lunes podés volver a improvisar la clase. O podés entrar al
          estudio con todo resuelto desde hoy.
        </h2>
        <p className="text-lg md:text-xl text-red-400 font-bold" data-id="element-51">
          ¿Cuánto cuesta NO tenerlo?
        </p>
      </div>

      {/* Desktop table */}
      <div className="max-w-4xl mx-auto hidden md:block" data-id="element-52">
        <table className="w-full text-left border-collapse" data-id="element-53">
          <thead data-id="element-54">
            <tr data-id="element-55">
              <th className="px-2 py-2 border-b border-white/10 w-8" data-id="element-56"></th>
              <th className="px-2 py-2 border-b border-white/10 text-red-400 font-display font-bold text-sm w-[45%] bg-red-500/5 rounded-tl-xl text-center" data-id="element-57">
                SIN STRETCHING RESUELTO
              </th>
              <th className="px-2 py-2 border-b border-white/10 text-brand-accent font-display font-bold text-sm w-[45%] bg-brand-accent/5 rounded-tr-xl text-center" data-id="element-58">
                CON STRETCHING RESUELTO
              </th>
            </tr>
          </thead>
          <tbody data-id="element-59">
            {comparisonRows.map((row, i) => <tr key={i} className="border-b border-white/5" data-id="element-60">
                <td className="px-2 py-1.5 text-base text-center" data-id="element-61">
                  {row.icon}
                </td>
                <td className="px-2 py-1.5 text-gray-400 bg-red-500/5 text-xs leading-tight text-center" data-id="element-62">
                  {row.sin}
                </td>
                <td className="px-2 py-1.5 text-white bg-brand-accent/5 font-medium text-xs leading-tight text-center" data-id="element-63">
                  {row.con}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="max-w-lg mx-auto md:hidden space-y-2" data-id="element-64">
        {comparisonRows.map((row, i) => <div key={i} className="rounded-lg border border-white/5 overflow-hidden" data-id="element-65">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-white/[0.03]" data-id="element-66">
              <span className="text-sm" data-id="element-67">{row.icon}</span>
            </div>
            <div className="grid grid-cols-2 divide-x divide-white/5" data-id="element-68">
              <div className="px-2.5 py-2 bg-red-500/5" data-id="element-69">
                <div className="text-red-400/70 text-[9px] font-bold uppercase tracking-wider mb-0.5" data-id="element-70">
                  Sin
                </div>
                <p className="text-gray-400 text-[11px] leading-snug" data-id="element-71">
                  {row.sin}
                </p>
              </div>
              <div className="px-2.5 py-2 bg-brand-accent/5" data-id="element-72">
                <div className="text-brand-accent/70 text-[9px] font-bold uppercase tracking-wider mb-0.5" data-id="element-73">
                  Con
                </div>
                <p className="text-white text-[11px] leading-snug font-medium" data-id="element-74">
                  {row.con}
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </Section>;
}